import { Program } from 'reducers/programs/types';
import { ProgramSchedule } from '../types';

const defaultSchedule = {
  mon: false,
  tue: false,
  wed: false,
  thu: false,
  fri: false,
  sat: false,
  sun: false,
};

const getScheduleByProgramId = (id: number, programs: Program[]): ProgramSchedule =>
  programs.find((p) => p.id === id)?.schedule || defaultSchedule;

export default getScheduleByProgramId;
